import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';

export const goToFoodDishesStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'foodDish1',
        title: '¡Vamos a crear tu primer receta!',
        text: `Da clic en "Mis recetas" para poder continuar.`,
        cancelIcon: {enabled: false},
        attachTo: {
          element: '.l-item-1-0',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.l-item-1-0',
          event: 'click'
        },
        buttons: [
          {
            ...buttons.cancel,
          }
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void => {
              resolve(true);
            }, 1000);
          });
        },
        classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
      }
    ];
  };
